import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from './form-field';
import { FormControlLabel } from '../primitives/label';
import { FieldValidationMessage } from './form-control/form-control-validation-error';
import { TextboxField } from '../components/form-fields';
import { IParams } from './text';

export interface IZipCodeInputProps {
	value: FormField<string>;
	formControlId: string;
	acceptanceTestTargetId: string;
	placeholder?: string;
	label: string;
	translationParams?: IParams;
}

@observer
export class ZipCodeInput extends React.Component<IZipCodeInputProps, {}> {
	render() {
		const { value,  formControlId, placeholder, label, acceptanceTestTargetId, translationParams } = this.props;
		const additionalClassNames = value.hasValidationError ? 'form-control-invalid' : '';

		return (
			<div className="form-control-container">
				<FormControlLabel formControlId={formControlId}>
					{label}
				</FormControlLabel>
				<TextboxField
					formField={value}
					formControlId={formControlId}
					placeholder={placeholder}
					dataFieldInvalid={value.hasValidationError}
					additionalClassNames={additionalClassNames}
					acceptanceTestTargetId={acceptanceTestTargetId} />
				<FieldValidationMessage translationParams={translationParams} errorMessage={value.validationError} />
			</div>
		);
	}
}
